// extracted by mini-css-extract-plugin
export default {"listNumbersTwoColumns":"orders-board_listNumbersTwoColumns__LOoX7","listOrdersBoard":"orders-board_listOrdersBoard__tSViK","listNumbers":"orders-board_listNumbers__CSf9V"};